import { PURCHASE_FRAGMENT } from '@/graphql/fragments/purchase'
import { gql } from '@apollo/client'

export const CART_FRAGMENT = gql`
  fragment CartFragment on Cart {
    amount
    amountVat
    amountWithVat
    vatRate
    createdAt
    id
    paymentType
    status
    purchases {
      ...PurchaseFragment
    }
    totalReduction
    firstRecurrentAmountByMonthWithReduction
  }
  ${PURCHASE_FRAGMENT}
`
